import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MetaService {

  // Configure SEO for each page here
  private seoConfig: any = {
    '/': {
      title: 'IIoT, Connected Mobility Platform and Enterprise Fleet Management | Varroc Connect',
      description: "Transform your operations with Varroc Connect's integrated IIoT and Connected Mobility Platform. Scalable solutions for enterprise fleet management, driver safety, and real-time intelligence.",
      keywords: 'connected vehicle intelligence,smart mobility platform,real-time vehicle insights,fleet management solutions,automotive data analytics,connected car technology,vehicle telematics platform'
    },
    '/products/automotive-cloud': {
      title: 'Automotive Cloud Platform for Vehicle Data Management | Varroc Connect',
      description: 'Advanced cloud for automotive data management. VC Auto, Insurance & TLS Cloud solutions. Centralized storage, processing & analysis of vehicle diagnostics and location data.',
      keywords: 'automotive cloud,automotive cloud platform,cloud for automotive'
    },
    '/products/automotive-score': {
      title: 'Automotive Health Monitor and Fuel Efficiency Analysis | Varroc Connect',
      description: 'AI automotive health monitor with personalized driving score. Real-time vehicle fuel efficiency tracking, traffic monitoring & car health insights for optimized performance.',
      keywords: 'vehicle fuel efficiency,automotive health,traffic monitor system,automotive monitor,car health monitoring,vehicle health monitoring,vehicle health monitor'
    },
    '/products/automotive-applications': {
      title: 'Car GPS Tracker App for Android & iOS | Varroc Connect',
      description: 'Track and control your car with the Varroc Connect GPS tracker app for Android & iOS. Get real-time vehicle insights, security and smart driving features.',
      keywords: 'gps tracker app, car tracking app, gps tracker for car app, car tracker app, car gps app, automobile tracker app, gps vehicle tracker app'
    },
    '/products/automotive-hardware': {
      title: 'Automotive Hardware for Car Tracking Device, ECU and OBD | Varroc Connect',
      description: 'Automotive tracking devices for cars. GPS tracker device, OBD device for car & Telematics Control Unit. Water-resistant fuel tracking device with hidden installation.',
      keywords: 'gps tracker device price, automobile tracking device, auto tracking devices for cars, car tracking device, ecu for car, automotive ecu, obd device for car, fuel tracking device'
    },
    '/solutions/automotive-smart-solutions': {
      title: 'Smart Car Automotive GPS Tracking System | Varroc Connect',
      description: 'Upgrade vehicles with Varroc Connect smart automotive GPS tracking system featuring real-time tracking, driver monitoring, vehicle health and intelligent connected car solutions.',
      keywords: 'automotive gps tracking system, auto solutions, automotive oems, car solutions, driver monitoring system, smart car solutions, auto monitoring system, car stacker, driver behavior monitoring system, vehicle health monitoring system'
    },
    '/solutions/automotive-banking-finance-insurance-services': {
      title: 'Automotive Financial & Banking Tracking Solutions | Varroc Connect',
      description: 'Varroc Connect offers a automotive financial services with vehicle insurance tracking and advanced automotive banking solutions designed for NBFCs and insurers.',
      keywords: 'automotive financial services,vehicle insurance tracking,automotive banking solutions'
    },
    '/solutions/automotive-vehicle-users-b2c-solutions': {
      title: 'Car History Check & Vehicle Monitoring System | B2C Car Solutions',
      description: 'Integrated real time vehicle tracking system with car servicing history. Smart driving behavior monitoring, comprehensive vehicle health insights & seamless automotive customer journey.',
      keywords: 'car history check,car servicing history,real time vehicle tracking system,vehicle monitoring system,driving behavior monitoring,automotive customer journey'
    },
    '/solutions/automotive-tls-solutions': {
      title: 'Logistics Tracking System & Auto Fleet Management | Varroc Connect',
      description: 'Track vehicles and shipments in real time with Varroc Connect automotive logistics tracking system Monitor detention time, geofences, safety index, parking hubs & analytics.',
      keywords: 'logistics tracking,logistics tracking system,auto logistics tracking'
    },
    '/cyber-security': {
      title: 'Cyber Security Solutions for Data Protection | Varroc Connect',
      description: "Protect your business with advanced cyber security solutions. Secure data, prevent threats, and ensure network safety with expert cybersecurity services.",
    },
    '/leadership': {
      title: 'Varroc Connect Leadership Team | Vision & Expertise	',
      description: 'Meet the Varroc Connect leadership team driving innovation and excellence in automotive solutions. Discover their vision, expertise, and commitment.',
      keywords: 'automotive solutions'
    },
    '/contact-us': {
      title: 'Contact Varroc Connect | Get in Touch for Support & Inquiries',
      description: 'Contact Varroc Connect for inquiries and support. Our team is ready to assist you with automotive solutions, including GPS tracker for car services.',
      keywords: 'gps tracker for car'
    },
    '/about-us': {
      title: 'Learn About Varroc Connect | Connected Vehicle Platform',
      description: 'Explore how Varroc Connect delivers innovative connected vehicle technology with automobile tracking devices, remote monitoring, and diagnostics insights since 2013.',
      keywords: 'automobile tracking device'
    },
    '/privacy-policy': {
      title: 'Privacy Policy | Varroc Connect Data Collection & Security',
      description: "Explore Varroc Connect's privacy policy to see how we protect personal data, use cookies, and ensure GPS tracker users' privacy and rights.",
    },
    '/refund-and-return-policy': {
      title: 'Refund & Return Policy | Varroc Connect Returns & Refunds',
      description: "Explore Varroc Connect's refund & return policy. Check eligibility, timelines & refund process for a seamless and transparent experience."
    },
    '/shipping-and-cancellation-policy': {
      title: 'Shipping & Cancellation Policy | Varroc Connect',
      description: 'Explore Varroc Connect Shipping & Cancellation Policy for your automobile tracking device, including delivery, charges, returns, refunds, and support.',
      keywords: 'automobile tracking device'
    },
    '/terms-and-conditions': {
      title: 'Terms & Conditions | Varroc Connect',
      description: "Explore Varroc Connect Terms & Conditions. Learn legal terms, user responsibilities, and data use for our car tracking device and telematics solutions.",
      keywords: 'car tracking device'
    },
    '/careers': {
      title: 'Careers at Varroc Connect | Join Our Innovative Team',
      description: 'Explore exciting career opportunities at Varroc Connect. Join our innovative team driving automotive technology with GPS tracking, telematics, and connected vehicle solutions.',
      keywords: 'automotive technology, gps tracking, telematics, connected vehicle solutions'
    },
    '/resources': {
      title: 'Free Resources Hub | Guides, Tools & Expert Insights',
      description: 'Explore our resource hub with expert guides, tools, and learning materials. Discover insights to enhance your knowledge and stay ahead.',
      keywords: 'automotive insights, gps tracking support, telematics updates, connected vehicle technology resources'
    },
    '/solutions': {
      title: 'Connected Mobility Solutions for OEM, Fleet, Insurance & Consumers | Varroc Connect',
      description: 'Explore Varroc Connect connected intelligence ecosystem combining telematics, cloud infrastructure, unified SDK, and scalable applications. Discover business solutions for OEM, fleet management, insurance telematics, and IoT, plus consumer experiences for connected vehicle insights, safety assistance, and Miles loyalty rewards.',
      keywords: 'connected mobility solutions, telematics platform, oem connected vehicle solutions, fleet management platform, insurance telematics, iot mobility solutions, connected vehicle experience, driver safety alerts, miles loyalty rewards, unified sdk ecosystem'
    },
    '/products': {
      title: 'ConnectIQ, Unified SDK & Telematics Hardware Products | Varroc Connect',
      description: 'Discover Varroc Connect products powering the connected ecosystem end-to-end. Explore ConnectIQ modules including Certificate Management, V-Store, Miles, iQ360, Customer Adoption Program, Score, Oasis dashboard, IIoT integration, and Vehicle App Store, along with Unified SDK and robust telematics hardware such as CAN devices, non-CAN devices, TCU, and dashcams.',
      keywords: 'connectiq platform, unified sdk, connected mobility products, certificate management, v-store marketplace, miles rewards engine, iq360, customer adoption program, oasis oem dashboard, iiot integration, vehicle app store, telematics hardware, can devices, non-can devices, telematics control unit, dashcam'
    },
    '/blog/geofencing-for-fleet-security-how-it-works': {
      title: 'Geofencing for Fleet Security: How It Works and Use Cases in India | Varroc Connect',
      description: "Meta description: Geofencing creates virtual boundaries around locations and triggers real-time alerts when vehicles enter or exit them. Here's how it works and how Indian fleets use it for security and efficiency.",
    }

  };

  constructor(
    private titleService: Title,
    private meta: Meta,
    private router: Router
  ) {
    this.listenToRouteChanges();
  }

  /** Automatically triggers on every route navigation */
  private listenToRouteChanges() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const path = event.urlAfterRedirects.split('?')[0];
        this.applySeo(path);
      });
  }

  /** Apply SEO settings based on the current path */
  private applySeo(path: string) {
    const config = this.seoConfig[path];

    if (!config) return; // No SEO config for this route

    // Set Title
    this.titleService.setTitle(config.title);

    // Set Description
    this.meta.updateTag({
      name: 'description',
      content: config.description
    });

    // Set Keywords
    this.meta.updateTag({
      name: 'keywords',
      content: config.keywords
    });

    // Optional: Add custom meta tags
    if (config.customTags) {
      config.customTags.forEach((tag: any) => {
        this.meta.updateTag(tag);
      });
    }
  }
}
